import User from "@/models/user";

export default class UserFactory {
  static createFromJson(json) {
    return new User(json);
  }
  static createFromJsonArray(jsonArray) {
    const jsonData = [];
    jsonArray.forEach((item) => {
      jsonData.push(UserFactory.createFromJson(item));
    });

    return jsonData;
  }
}
